import dataLayer from '../dataLayer/reducer';
import grey from '@material-ui/core/colors/grey';
import { TOGGLE_ALL as TOGGLE_ALL_IND, TOGGLE_IDUSTRY } from '../mapData/actions';
import { TOGGLE_ALL as TOGGLE_ALL_EMP_, TOGGLE_EMPLOYED_BY_NAME as TOGGLE_EMPLOYED_BY_NAME_ } from '../employedCount/actions';
import { TOGGLE_ALL_TYPE as TOGGLE_ALL_EMP_VEIDS, TOGGLE_EMPLOYED_BY_NAME as TOGGLE_EMPLOYED_BY_NAME_VEIDS } from '../employedCountVeids/actions';
import { TOGGLE_POP } from '../population/actions';

const yellow = 'rgb(228, 218, 100)';

export const DefaultState = {
    active: [],
    activeData: [],
    id: 1,
    data: [{
    //    icon: <SchoolIcon style={{width:'25px', height: '25px'}} />,
        name: 'Skolas',
        textStyle: {color: grey[800]},
        style: {fontSize: '1em', color: grey[300], borderBottom:'1px solid ' + grey[300] },
        childs: [
            { id: 'school_types', style: {fontSize: '13px'}, name: 'Skolu tipi', group: 'types', active: false, 
                tooltip: true, tooltipText: 'Apļdiagrammas vai tās sektora laukums proporcionāls skolēnu skaitam attiecīgā tipa skolā 1.septembrī',
            }, //schoolTypes
        //    { id: 'middle_school_model', name: 'Vidusskolu tīkla modelis', group: 'schoolsnetwork', active: false, style: {fontSize: '13px'}},
            { id: 'quality_indicator', style: {fontSize: '13px'}, name: 'Skolu kvalitatīvie rādītaji', childs: 
                [
                    {id:'attiecib2', exact_val: 'attieciba', name: 'Skolēnu un skolotāju skaita attiecība ([[schoolyear2]])', sizeField:'kopa', 
                    tooltip: true, 
                    tooltipText: '1.septembrī skolā uzrādītais skolēnu skaits dalīts ar skolotāju - sākumizglītības skolotāju, pamatizglītības skolotāju, vidējās izglītības skolotāju un speciālās izglītības skolotāju, kam tā ir pamatdarbavieta – skaitu attiecīgajā skolā; apļdiagrammas vai tās sektora  laukums proporcionāls skolēnu skaitam attiecīgā līmeņa skolā',
                        order: ['nav datu', '<5', '5-7', '7-9', '9-11', '11-13', '>13'],
                        colors: [
                            'rgb(157, 159, 162)',
                            'rgb(0, 155, 177)',
                            'rgb(101, 160, 206)',
                            'rgb(213, 225, 234)',
                            yellow,
                            'rgb(251, 175, 93)',
                            'rgb(243, 116, 67)',
                            'rgb(237, 20, 91)',
                        ],
                        filters: {
                            classes: [],
                            types: []
                        }
                    },
                    {id:'OCE_grupa', exact_val: 'OCE', name:'Obligāto eksāmenu indekss, % ([[schoolyear]])', sizeField:'12kl2015',
                        order: ['<30%', '30-40%', '40-50%', '50-60%', '60-70%', '>70%'],
                        tooltip: true, 
                        tooltipText: 'trīs vidusskolas obligāto centralizēto eksāmenu - latviešu valodas, matemātikas un svešvalodas (angļu, franču, vācu vai krievu) valodas eksāmenu vērtējumu summa dalīta ar skolā mācību gada sākumā norādīto 12.kl. skolēnu skaitu un dalīta ar 3; apļdiagrammas vai tās sektora  laukums proporcionāls 12.kl. skolēnu skaitam attiecīgā līmeņa skolā vispārējās izglītības programmā',
                        colors: [
                            'rgb(0, 155, 177)',
                            'rgb(101, 160, 206)',
                            'rgb(213, 225, 234)',
                            yellow,
                            'rgb(251, 175, 93)',
                            'rgb(243, 116, 67)',
                            'rgb(237, 20, 91)',
                        ]
                    }, //12kl2015
                    {id:'dabas_grup', exact_val: 'dabas', name:'Dabaszinātņu indekss, % ([[schoolyear]])', sizeField:'12kl2015',
                        order: ['neviens nekārtoja', '0,1-2%', '2-4%', '4-6%', '6-8%', '>8%'], 
                        tooltip: true,
                        tooltipText: 'centralizēto fizikas, ķīmijas un bioloģijas eksāmenu vērtējumu summa dalīta ar skolā mācību gada sākumā norādīto 12.kl. skolēnu skaitu un dalīta ar 3; apļdiagrammas vai tās sektora  laukums proporcionāls 12.kl. skolēnu skaitam attiecīgā līmeņa skolā vispārējās izglītības programmā',
                        colors: [
                            'rgb(}57, 159, 162)',
                            'rgb(0, 155, 177)',
                            'rgb(213, 225, 234)',
                            yellow,
                            'rgb(251, 175, 93)',
                            'rgb(243, 116, 67)',
                            'rgb(237, 20, 91)',
                        ]
                    }, //12kl2015

                    {id:'kartot_gr', exact_val: 'kartot', name:'Vidusskolas eksāmenu nokārtojušo īpatsvars, % ([[schoolyear]])', sizeField:'12kl2015',
                        order: ['nav datu', '<50%', '50-60%', '60-70%', '70-80%', '80-90%', '>90%'],
                        tooltip: true,
                        tooltipText: 'trīs vidusskolas obligāto centralizēto eksāmenu - latviešu valodas, matemātikas un svešvalodas (angļu, franču, vācu vai krievu) valodas eksāmenus nokārtojušo skolēnu īpatsvars skolā mācību gada sākumā norādīto 12.kl. skolēnu skaitā; apļdiagrammas vai tās sektora  laukums proporcionāls 12.kl. skolēnu skaitam attiecīgā līmeņa skolā vispārējās izglītības programmā',
                        colors: [
                            'rgb(157, 159, 162)',
                            'rgb(0, 155, 177)',
                            'rgb(213, 225, 234)',
                            yellow,
                            'rgb(251, 175, 93)',
                            'rgb(243, 116, 67)',
                            'rgb(237, 20, 91)',
                        ]
                    }, //12kl2015

                    {id:'pamat_grup', exact_val: 'pamat', name:'Pamatskolas eksāmenu indekss, % ([[schoolyear]])', sizeField:'9kl2015',
                        order: ['neviens nekārtoja', 'nav datu', '<30%', '30-40%', '40-50%', '50-60%', '60-70%', '>70%'],
                        tooltip: true,
                        tooltipText: 'četru obligāto decentralizēto pamatskolas eksāmenu - latviešu (mazākumtautību skolās krievu vai poļu) valodas, matemātikas, vēstures, svešvalodas (angļu, franču, vācu vai krievu) vērtējumu summa, dalīta ar skolā mācību gada sākumā norādīto 9.kl. skolēnu skaitu, dalīta ar 4; apļdiagrammas vai tās sektora  laukums proporcionāls 9.kl. skolēnu skaitam attiecīgā līmeņa skolā vispārējās izglītības programmā',
                        colors: [
                            'rgb(82, 82, 82)',
                            'rgb(157, 159, 162)',
                            'rgb(0, 155, 177)',
                            'rgb(101, 160, 206)',
                            'rgb(213, 225, 234)',
                            yellow,
                            'rgb(251, 175, 93)',
                            'rgb(243, 116, 67)',
                            'rgb(237, 20, 91)',
                        ]
                    }, //9kl2015

                    {id:'kartot2_gr', exact_val: 'kartot2', name:'Pamatskolas eksāmenu nokārtojušo īpatsvars, % ([[schoolyear]])', sizeField:'9kl2015', 
                        order: ['neviens nekārtoja', 'nav datu', '<50%', '50-60%', '60-70%', '70-80%', '80-90%', '>90%'],
                        tooltip: true,
                        tooltipText: 'četru obligāto decentralizēto pamatskolas eksāmenu - latviešu (mazākumtautību skolās krievu vai poļu) valodas, matemātikas, vēstures, svešvalodas (angļu, franču, vācu vai krievu) – nokārtojušo īpatsvars skolā mācību gada sākumā norādīto 9.kl. skolēnu skaitā; apļdiagrammas vai tās sektora  laukums proporcionāls 9.kl. skolēnu skaitam attiecīgā līmeņa skolā vispārējās izglītības programmā',
                        colors: [
                            'rgb(82, 82, 82)',
                            'rgb(157, 159, 162)',
                            'rgb(0, 155, 177)',
                            'rgb(101, 160, 206)',
                            'rgb(213, 225, 234)',
                            yellow,
                            'rgb(251, 175, 93)',
                            'rgb(243, 116, 67)',
                            'rgb(237, 20, 91)',
                        ]
                    }, //9kl2015

                    {id:'alga_grupa', exact_val: 'alga', name: 'Skolotāju vidējā alga, EUR ([[schoolyear2]])', sizeField:'kopa',
                        order: ['nav datu', '<300 EUR', '300-400 EUR', '400-500 EUR', '500-600 EUR', '600-700 EUR', '700-800 EUR', '>800 EUR'],
                        tooltip: true,
                        tooltipText: 'skolotāju - sākumizglītības skolotāju, pamatizglītības skolotāju, vidējās izglītības skolotāju un speciālās izglītības skolotāju - vidējā alga ar valsts piemaksām, neņemot vērā VSOAI, pašvaldību piemaksas un iespējamo algu pārdali; apļdiagrammas vai tās sektora laukums proporcionāls skolēnu skaitam attiecīgā līmeņa skolā vispārējās izglītības programmā',
                        colors: [
                            'rgb(157, 159, 162)',
                            'rgb(0, 155, 177)',
                            'rgb(101, 160, 206)',
                            'rgb(213, 225, 234)',
                            yellow,
                            'rgb(251, 175, 93)',
                            'rgb(243, 116, 67)',
                            'rgb(237, 20, 91)',
                        ]
                    },
                    {id:'noslodze_g', exact_val: 'noslodze', name:'Skolotāju vidējā noslodze, % ([[schoolyear2]])', sizeField:'kopa',
                        order: ['nav datu', '<40%', '40-50%', '50-60%', '60-70%', '70-80%', '80-90%', '>90%'],
                        tooltip: true,
                        tooltipText: 'skolotāju - sākumizglītības skolotāju, pamatizglītības skolotāju, vidējās izglītības skolotāju un speciālās izglītības skolotāju - tarificētā vidējā slodze no 30 stundu pamatslodzes; apļdiagrammas vai tās sektora  laukums proporcionāls skolēnu skaitam attiecīgā līmeņa skolā vispārējās izglītības programmā',
                        colors: [
                            'rgb(157, 159, 162)',
                            'rgb(0, 155, 177)',
                            'rgb(101, 160, 206)',
                            'rgb(213, 225, 234)',
                            yellow,
                            'rgb(251, 175, 93)',
                            'rgb(243, 116, 67)',
                            'rgb(237, 20, 91)',
                        ]
                    }
                ]
            }
        ]
        }
    ]
}

class SMDDataLayer extends dataLayer {

    reducerExtender(state, action) {    
        
        switch(action.type) {
            
            case 'sportInfrastructure_TOGGLE_BY_IDS_SINGLE':
            case TOGGLE_POP:
            case TOGGLE_ALL_EMP_VEIDS:
            case TOGGLE_EMPLOYED_BY_NAME_VEIDS:
            case TOGGLE_ALL_EMP_:
            case TOGGLE_EMPLOYED_BY_NAME_:
            case TOGGLE_ALL_IND:
            case TOGGLE_IDUSTRY:

                var newstate = Object.assign({}, state);

                this.recursiveLoop(newstate.data, (entry)=>{
               
                        entry.active = false;
     
                });

                return newstate;
            break;
            case 'mobility_ACTIVATE_BY_IDS':
                if(action.data.indexOf("dev_center_atta") > -1) {

                    var newstate = Object.assign({}, state);
                    this.recursiveLoop(newstate.data, (entry)=>{
                        if(entry.id === 'middle_school_model') {
                            entry.active = false;
                        }
                    });
                }

                return newstate;
            break;

            case 'electricUsage_TOGGLE_BY_IDS_SINGLE':

                var newstate = Object.assign({}, state);
                this.recursiveLoop(newstate.data, (entry)=>{
                    if(entry.id !== 'middle_school_model') {
                        entry.active = false;
                    }
                });

                return newstate;
              
            break;
            
            case 'population_TOGGLE_BY_IDS_SINGLE':
                var newstate = Object.assign({}, state);
                this.recursiveLoop(newstate.data, (entry)=>{
                    if(entry.id !== 'middle_school_model') {
                        entry.active = false;
                    }
                });
                
                return newstate;
            break;
        }

    }
}


var SchoolMenuData = new SMDDataLayer({
  key: "schoolMenu",
  defaultState: DefaultState
});



const SchoolMenuExport = SchoolMenuData.export();

export const schoolMenu = SchoolMenuExport.schoolMenu;
export default SchoolMenuExport;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/schoolMenu/reducer.js